import React, {useEffect, useRef, useState} from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import * as Yup from "yup";
import {
    FORM,
    INTERNATIONAL,
    REQUIRED
} from "../../../components/i18n/i18n";
import { useForm} from "react-hook-form";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Collapse,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import Switch from "react-bootstrap-switch";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import {eventService} from "../../../jwt/_services/core/eventService";
import SelectGeneric from "../../../components/select/selectGeneric";
import {categoryService} from "../../../jwt/_services/clasificator/categoryService";
import {categoryProvider} from "../../../providers/categoryProvider";
import {typeCatProvider} from "../../../providers/typeCatProvider";
import CategoryLangs from "./_langs";
import {setForm, setItem, setViewMode} from "../../../redux/actions/generics/IndexedActions";
import {udnProvider} from "../../../providers/udnProvider";

const CategoryForm = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, editMode, domainObject, udn} = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [isExtraordinary, setIsExtraordinary] = useState( domainObject?.isExtraordinary !== undefined ? domainObject?.isExtraordinary : false);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [translatableLangs ] = useState(domainObject?.translatableLangs || []);

    const [parentId, setParentId] = useState(domainObject?.parent?.id || null);
    const [typeId, setTypeId] = useState(domainObject?.type || null);


    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `cat_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE

            icon: domainObject?.icon,
            colorHex: domainObject?.colorHex,
            colorRgb: domainObject?.colorRgb,
            image: domainObject?.image,
            showOrder: domainObject?.showOrder,
            isExtraordinary: domainObject?.isExtraordinary,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                status: status,

                langs: langs,
            }
        }

        if (udn !== undefined && udn !== null )
            dataRequest.item.udn = { id : udn.id };

        if (parentId !== undefined && parentId !== null )
            dataRequest.item.parent = { id : parentId };
        else
            dataRequest.item.parent = null;

        if (typeId !== undefined && typeId !== null )
            dataRequest.item.type = typeId;
        else
            dataRequest.item.type = null;

        // console.log(dataRequest);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, categoryService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, categoryService, dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    const notImplementedAction = () => {
        console.log('sin implementar');
    }

    const formAny = () => {
        return (
            <div>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Codigo'}</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder="Ingrese codigo"
                                   innerRef={register}
                                   className={(errors.code ? ' is-invalid' : '')}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Icono'}</Label>
                            <Input type="text"
                                   name="icon"
                                   placeholder="Ingrese icono"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Imagen</Label>
                            <br/>
                            <Input type="text" name="image"
                                   placeholder="Imagen"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Categoria padre'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={parentId}
                                setExternalValue={setParentId}
                                provider={categoryProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Orden'}</Label>
                            <br/>
                            <Input type="number"
                                   name="showOrder"
                                   step={1}
                                   placeholder="0"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Extraordinaria'}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={isExtraordinary}
                                    onChange={_ => setIsExtraordinary(!isExtraordinary)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Activo'}</Label>
                            <br/>
                            <Switch animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                </Row>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>Color</Label>
                            <br/>
                            <Input type="color"
                                   name="colorHex"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Tipo'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={typeId}
                                setExternalValue={setTypeId}
                                provider={typeCatProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">

                    </Col>
                </Row>
            </div>
        )
    }

    const formPark = () => {
        return (
            <div>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Codigo'}</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder="Ingrese codigo"
                                   innerRef={register}
                                   className={(errors.code ? ' is-invalid' : '')}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Icono'}</Label>
                            <Input type="text"
                                   name="icon"
                                   placeholder="Ingrese icono"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Imagen</Label>
                            <br/>
                            <Input type="text" name="image"
                                   placeholder="Imagen"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Categoria padre'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={parentId}
                                setExternalValue={setParentId}
                                provider={categoryProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Orden'}</Label>
                            <br/>
                            <Input type="number"
                                   name="showOrder"
                                   step={1}
                                   placeholder="0"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Extraordinaria'}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={isExtraordinary}
                                    onChange={_ => setIsExtraordinary(!isExtraordinary)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Activo'}</Label>
                            <br/>
                            <Switch animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Color</Label>
                            <br/>
                            <Input type="color" name="colorHex"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Tipo'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={typeId}
                                setExternalValue={setTypeId}
                                provider={typeCatProvider}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="4">

                    </Col>
                </Row>
            </div>
        )
    }

    const formEvents = () => {
        return (
            <div>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Codigo'}</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder="Ingrese codigo"
                                   innerRef={register}
                                   className={(errors.code ? ' is-invalid' : '')}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Activo'}</Label>
                            <br/>
                            <Switch animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                </Row>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Icono'}</Label>
                            <Input type="text"
                                   name="icon"
                                   placeholder="Ingrese icono"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Imagen</Label>
                            <br/>
                            <Input type="text" name="image"
                                   placeholder="Imagen"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Categoria padre'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={parentId}
                                setExternalValue={setParentId}
                                provider={categoryProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Extraordinaria'}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={isExtraordinary}
                                    onChange={_ => setIsExtraordinary(!isExtraordinary)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Color</Label>
                            <br/>
                            <Input type="color" name="colorHex"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{'Tipo'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={typeId}
                                setExternalValue={setTypeId}
                                provider={typeCatProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">

                    </Col>
                </Row>
            </div>
        )
    }

    const getInternational = () => {
        return (
            <div>
                <div className={''}>
                    <h2>{INTERNATIONAL}</h2>
                </div>
                <div className={''}>
                    <Row>
                        <Col>
                            <CategoryLangs langs={langs} setLangs={setLangs} translatableLangs={translatableLangs} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={ 'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={eventService} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_DELETE}
                                    icon={'fa-trash'}
                                    permission={'delete'}
                                    onClick={notImplementedAction}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            {(
                            function() {
                                switch (app.code) {
                                    case "PARK" :
                                        return formPark();
                                    case "EVENTS" :
                                        return formEvents();
                                    default:
                                        return formAny();
                                }
                            })()}
                        </Col>
                    </Row>
                    { getInternational() }
                </CardBody>
            </Card>
        </Form>

        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setViewMode,
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(CategoryForm)